import styled, { css } from 'styled-components';

export const SelectedApplication = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`;

export const SelectedApplicationTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  `}
`;

export const SelectedApplicationTitleIcon = styled.img`
  width: 40px;
  height: 40px;
  display: block;
`;

export const SelectedApplicationDescription = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin-top: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ProvisionedText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin-top: 16px;
    display: block;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const SelectWrapper = styled.div`
  width: 100%;

  div > {
    width: 100%;
  }
`;

export const RequestDomainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RequestDomainDescription = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0;
    display: block;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const RequestDomainInputList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const RequestDomainInputListItem = styled.li`
  ${({ theme, $checked }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: row;
    gap: 0 18.5px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 16px;
    user-select: none;
    transition: .3s;    
    padding: 16px;
    cursor: pointer;

    ${$checked && css`
      border-color: ${theme.v2.colors.brand.primaryMedium};
      box-shadow: 0 0 20px 0 ${theme.v2.colors.brand.primaryMedium}33;
    `}

    &:hover {
      border-color: ${theme.v2.colors.brand.primaryMedium};
      box-shadow: 0 0 20px 0 ${theme.v2.colors.brand.primaryMedium}33;
    }       
  `};
`;

export const RequestDomainInputListItemRadio = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    > button {
      padding: 2px 0px 0 0;
    }
`;

export const RequestDomainInputListItemCollapse = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const RequestDomainInputListItemLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `};
`;

export const RequestDomainInputListItemContent = styled.span`
  ${({ theme, $checked }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0;
    width: 100%;
    gap: 8px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }

    ${!$checked && css`
      display: none;
    `}

    ${$checked && css`
      display: flex;
    `}
    
    p {
      margin: 0;
    }

    span {
      font-weight: ${theme.v2.font.weights.regular};
      font-size: ${theme.v2.font.sizes.xxxs};
    }

    #labelWrapper {
      &:before{
        content: 'www.';
        display: block;
        font-size: ${theme.v2.font.sizes.xxs};
        color: ${theme.v2.colors.neutral.lowMedium};
        font-weight: ${theme.v2.font.weights.regular};
        padding-right: 16px;

        @media (max-width: ${theme.v2.breakpoints.md}) {
          font-size: ${theme.v2.font.sizes.xxxs};
        }
      }

      label {
        left: 51px;
        width: calc(100% - 51px - 8px);
      }
    }
  `}
`;
